import { ChangeDetectorRef, AfterViewInit, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { UploadModule } from '@progress/kendo-angular-upload';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { GridService } from 'app/services/grid.service';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConfigService } from '../../services/config.service';
import { TranslocoPipe } from '@ngneat/transloco';
import { ButtonsModule } from '@progress/kendo-angular-buttons'
import { SVGIcon, saveIcon, pencilIcon, trashIcon, plusCircleIcon, cancelCircleIcon, checkCircleIcon } from '@progress/kendo-svg-icons';
import { FuseAlertComponent } from '@fuse/components/alert';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { PagerModule } from '@progress/kendo-angular-pager';
import { MatDialog } from '@angular/material/dialog';
import { FileManagerComponent } from '../file-manager/file-manager.component'; 
import { FileService } from 'app/services/file.service';
import { DrakeFieldComponent } from '../drake-field/drake-field.component';





@Component({
    selector: 'app-drake-timeline',
    templateUrl: './drake-timeline.component.html',
    styleUrls: ['./drake-timeline.component.scss'],
    standalone: true,
    providers: [TranslocoPipe],
    imports: [DrakeFieldComponent, CommonModule, InputsModule, DropDownsModule, UploadModule, DateInputsModule, FormsModule, MatIconModule, TranslocoPipe, ButtonsModule,FuseAlertComponent,ListViewModule,PagerModule]
})
export class DrakeTimelineComponent implements AfterViewInit, OnChanges {

    @Input() public config: any;
    @Input() public baseData: any;
    @Input() public scope: string;
    @Input() public titleField: string;
    @Input() public descriptionField: string;
    @Input() public parentField: string;
    @Input() public orderField: string;
    @Input() public parentId: string;
    @Input() public readonly: boolean;
    @Input() public galleryField: string;  
    @Input() public extraFields: any[] = []; 
    @Input() public viewCode: string;

    
    public editingStates: { [key: string]: boolean } = {};
    private initialized = false;
    private dataLoaded = false;
    public data: Array<any> = [];
    private commandName: string = "READ";
    public editingId: string = null;
    public editSVG: SVGIcon = pencilIcon;   
    public deleteSVG: SVGIcon = trashIcon;
    public saveSVG: SVGIcon = saveIcon;
    public newSVG: SVGIcon = plusCircleIcon;
    public cancelSVG: SVGIcon = cancelCircleIcon
    public endSVG: SVGIcon = checkCircleIcon;
    public pagedData: any[] = [];
    public pageSize: number = 5; // Items per page
    public skip: number = 0;
    public viewFields: any[] = [];
    public fieldConfig: any;  
    public viewConfig: any = { viewFields: [] };
    public extraFieldsArray: Array<any> = [];


  

    constructor(
        private dialog: MatDialog,
        private gridService: GridService,
        private drakeSharedService: DrakeSharedService,
        private http: HttpClient,
        private configService: ConfigService,
        private fileService: FileService,
        private cdRef: ChangeDetectorRef,
        private translocoPipe: TranslocoPipe

    ) {

    }

    ngAfterViewInit(): void {
        this.cdRef.detectChanges();
    }

      
      ngOnInit() {
        if (!this.initialized) {
            //this.loadData();
            this.loadExtraFieldsConfig();
            this.initialized = true;
        }
    }
    
    
    loadExtraFieldsConfig() {
        if (this.viewConfig.viewFields.length === 0) {
            this.extraFields.forEach(field => {
                this.gridService.GetScopeFieldForView(field.fieldCode).subscribe(
                    (response: any) => {
                        this.viewConfig.viewFields.push({
                            ...response,
                            header: field.label
                        });
                        this.cdRef.detectChanges();
                    },
                    (error) => {
                        console.error(`Error fetching field configuration for ${field.fieldCode}`, error);
                    }
                );
            });
            console.log("viewConfig", this.viewConfig.viewFields);
        }
    }
    
    valueChanged(event: any): void {
        const { field, value } = event;
        const item = this.data.find(i => i._id === this.editingId);
        if (item) {
          item[field] = value;
          console.log(`Field ${field} changed to ${value} for item`, item);
        }
        this.cdRef.detectChanges(); 
    }
      

    openFileManager(item: any): void {
        const dialogRef = this.dialog.open(FileManagerComponent, {
            width: '80%',
            height: '80%',
            data: { fileCtrlFormat: 'IMAGE' } 
        });
    
        dialogRef.afterClosed().subscribe(result => {
            if (result && result.dataUrl && result.id) { 
                if (!item[this.galleryField]) {
                    item[this.galleryField] = []; 
                }
                item[this.galleryField].push({
                    ImageFile: result.id, 
                    ImageDataUrl: result.dataUrl,  
                    ImageDescription: result.fileName,  
                    ImageOrder: item[this.galleryField].length + 1
                });
            }
        });
    }
    
    
    loadData(): void {

        console.log('Inizio caricamento dati...');
        var viewCodeVar = this.config.componentView.viewCode;
        if(this.viewCode)
            viewCodeVar = this.viewCode;
        var objSort = {};
        var objFilter = {};
        objFilter[this.parentField] = this.parentId;
        objSort[this.orderField] = 1;
        const requestData = {
            ViewCode: viewCodeVar,
            Filter: JSON.stringify(objFilter),
            Sort: JSON.stringify(objSort),
            Page: 0,
            PageSize: 0,
            Language: "",
            Cache: false,
            ExtraData: {}
        };
    
        console.log('requestData: ', requestData);
    
        this.gridService.getScopeDataSimple(this.scope, this.commandName, requestData).subscribe(
            (response: any) => {
                console.log('Risposta ricevuta: ', response);
                this.data = response.data.map((item: any) => {
                    for (let key in item) {
                        if (item[key] === null || item[key] === undefined) {
                            item[key] = '';
                            if(key == this.galleryField)
                                item[key] = [];
                        }
                    }
    
                    const imagesArray = item[this.galleryField]?.map((image, index) => {
                        let imageObj = {
                            ImageFile: image.ImageFile || '',  
                            ImageDataUrl: '', 
                            ImageDescription: image.ImageDescription || '', 
                            ImageOrder: index + 1 
                        };
    
                        // Leggi il file come base64
                        if (image.ImageFile) {
                            this.fileService.readFileAsBase64String(image.ImageFile.id).subscribe((fileRes: any) => {
                                imageObj.ImageDataUrl = `data:${fileRes.contentType};base64,${fileRes.fileContentBase64}`;
                            }, (error) => {
                                console.error('Errore nel caricamento dell\'immagine:', error);
                            });
                        }
    
                        return imageObj;
                    }) || [];
                    if (item.extraFields && Array.isArray(item.extraFields)) {
                        item.extraFields.forEach(field => {
                            if (field.fieldCode && field.value !== undefined) {
                                item[field.fieldCode] = field.value;
                            }
                        });
                    }
                    return {
                        ...item,
                        [this.galleryField]: imagesArray
                    };
                });
                this.cdRef.detectChanges();
                console.log('Dati caricati con immagini:', this.data);
            },
            (error) => {
                console.error('Errore nel caricamento dei dati', error);
            }
        );
        this.dataLoaded = true;
        this.cdRef.detectChanges();
    }
    
    
    


    ngOnChanges(changes: SimpleChanges) {
        if ((changes.scope || changes.parentId) && this.scope && this.parentId && this.initialized) {
            this.loadData();
        }
    }

    public pageChange(event: any): void {
        this.skip = event.skip;

        this.pagedData = this.data.slice(this.skip, this.skip + this.pageSize);
      }

    addElement() {
        var item = {};
        item["_id"] = "#NEWID#";
        item[this.titleField] = "";
        item[this.descriptionField] = "";
        item[this.orderField] = this.data.length + 1;
        item[this.parentField] = this.parentId;

        this.editingId = "#NEWID#";

        this.data.push(item)
    }
    editElement(item: any) {
        this.editingId = item._id;
        this.editingStates[item._id] = true;
    }
    deleteElement(item: any) {
        this.data = this.data.filter(itm => itm !== item);
        const reqData = {

            _id: item._id

        };        this.gridService.deleteScopeData("CTRLACTIONS", "DELETE", reqData).subscribe(
            (result: any) => {
                var notification = this.translocoPipe.transform("notification.success.timeline.remove");
                this.drakeSharedService.showTemporaryNotification(notification, 'success');
                this.editingStates[item._id] = false;
                this.editingId = null;
                this.loadData(); // Reload data after saving
            },
            (err: any) => {
                console.log(err);
                var notification = this.translocoPipe.transform("notification.error.timeline.remove");
                this.drakeSharedService.showTemporaryNotification(notification, 'error');
            }
        );
    }
    cancelEditElement() {
        if (this.editingId) {
            this.editingStates[this.editingId] = false;
        }
        this.editingId = null;
        this.loadData();
    }
    
    onFieldChange(event: any) {
        const { field, value } = event;
        console.log(`Field ${field} changed to ${value}`);
    } 

    
    checkFieldInExtraFields(field: any): boolean{
        //console.log("FIELD EXTRA FIELDS" , field);
        //console.log("EXTRA FIELDS" , this.extraFields);
        if(this.extraFields.filter(f => f.fieldCode == field.fieldCode ).length > 0 )
            return true;
        else
            return false;
    }

    saveElement(item: any) {
        const imagesArray = item[this.galleryField]?.map((image, index) => ({
            ImageFile: image.ImageFile,  // Save the image ID
            ImageDataUrl: image.ImageDataUrl,  // Save the image data URL for display
            ImageDescription: image.ImageDescription || 'No description', // Image description
            ImageOrder: index + 1 // Image order
        }));
    
        const extraFieldsArray = this.viewConfig.viewFields.map(field => ({
            fieldCode: field.fieldCode, // Usa fieldCode invece di columnCode
            value: item[field.fieldCode] // Usa il valore corrispondente dal campo
        }));
    
        const dataToSave = {
            ...item,
            [this.galleryField]: imagesArray,
        };

    
        console.log("Saving data: ", dataToSave);
    
        this.gridService.saveScopeData(this.scope, "UPSERT", dataToSave, false).subscribe(
            (result: any) => {
                var notification = this.translocoPipe.transform("notification.success.timeline.save");
                this.drakeSharedService.showTemporaryNotification(notification, 'success');
                this.editingStates[item._id] = false;
                this.editingId = null;
                this.loadData(); // Reload data after saving
            },
            (err: any) => {
                console.log(err);
                var notification = this.translocoPipe.transform("notification.error.timeline.save");
                this.drakeSharedService.showTemporaryNotification(notification, 'error');
            }
        );

    }
    
    removeImage(item: any, imageIndex: number): void {
        // Remove the image from the local array
        item[this.galleryField].splice(imageIndex, 1);

    
    }

    isReadOnly(item: any): boolean {
        return this.readonly || !this.editingStates[item._id];
    }
}
